import { render, staticRenderFns } from "./AcknowledgeReceipt.vue?vue&type=template&id=4fd06b58"
import script from "./AcknowledgeReceipt.vue?vue&type=script&lang=js"
export * from "./AcknowledgeReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports